/** A failed read must remain distinct from a successful empty result. */
export function DataUnavailable({
  message = "This widget could not be loaded.",
  retry,
}: {
  message?: string;
  retry: () => unknown;
}) {
  return (
    <div role="alert" className="rounded border border-red-200 bg-red-50 p-3 text-sm text-red-800">
      <p>{message}</p>
      <button type="button" className="mt-1 font-medium underline" onClick={() => void retry()}>Retry</button>
    </div>
  );
}
